import React from "react";
import ConfiguracionModule from "./ConfiguracionModule";

export default function CatalogosConfiguracion() {
  return <ConfiguracionModule group="catalogos" />;
}
